import { isFunction, isUef } from "./type";
import { LOCALE_CN, LOCALE_TW, LOCALE_EN } from '../constant';

let awscRequesting = false;

function loadAWSC() {
  if (awscRequesting) return Promise.reject();

  if (isUef(window.AWSC)) {
    awscRequesting = true;

    return new Promise((resolve, reject) => {
      const headEl = document.getElementsByTagName('HEAD').item(0);
      const scriptEl = document.createElement('script');

      scriptEl.type = 'text/javascript';
      scriptEl.src = 'https://g.alicdn.com/AWSC/AWSC/awsc.js';
      scriptEl.onload = function () {
        resolve();
      };
      scriptEl.onerror = function () {
        reject('LOAD_FAILURE');
      };

      headEl.appendChild(scriptEl);
    });
  }

  return Promise.resolve();
}

export class TrancelessAwsc {
  constructor(options) {
    this.options = { ...options };
    this.key = `_AWSC_${options.element}`;
    this.validatorRendered = false;
  }

  init() {
    return new Promise(async (resolve, reject) => {
      try {
        if (isUef(window.AWSC)) {
          await loadAWSC();
        }
  
        const { appkey, scene, onSuccess, onFail, onError } = this.options;
        const key = this.key;
        
        if (window[key]) return;

        window.AWSC.use('nvc', (state, module) => {
          // 初始化
          window[key] = module.init({
            // 应用类型标识。它和使用场景标识（scene字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
            appkey: appkey,
            //使用场景标识。它和应用类型标识（appkey字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的scene值，请务必正确填写。
            scene: scene,
            // test: module.TEST_NC_PASS,
            //前端滑动验证通过时会触发该回调参数。您可以在该回调参数中将会话ID（sessionId）、签名串（sig）、请求唯一标识（token）字段记录下来，随业务请求一同发送至您的服务端调用验签。
            success: function (data) {
              if (isFunction(onSuccess)) {
                onSuccess(data);
              }
            },
            // 滑动验证失败时触发该回调参数。
            fail: function (failCode) {
              if (isFunction(onFail)) {
                onFail(failCode);
              }
            },
            // 验证码加载出现异常时触发该回调参数。
            error: function (errorCode) {
              if (isFunction(onError)) {
                onError(errorCode);
              }
            }
          });
          resolve(window[key]);
        });
      } catch(e) {
        reject(e);
      }
    });
  }

  formatLang(lang) {
    const map = {
      [LOCALE_CN]: 'cn',
      [LOCALE_TW]: 'tw',
      [LOCALE_EN]: 'en',
    };
    return map[lang];
  }
  
  getAwscResult(cb) {
    window[this.key].getNVCValAsync((result) => {
      if (isFunction(cb)) {
        cb(result);
      }
    });
  }

  renderValidator() {
    const { element, language } = this.options;
    if (this.validatorRendered) {
      this.show();
    }

    this.validatorRendered = true;

    window[this.key].getNC({
      renderTo: element,
      language: this.formatLang(language),
      upLang: {
        'cn': {
          // 'SLIDE': "请按住滑块，拖动到最右边",
        },
      },
    });
  }

  destroy() {
    const elementEl = document.getElementById(this.options.element);
    if (elementEl) {
      elementEl.innerHTML = '';
      elementEl.className = '';
    }
    delete window[this.key];
  }

  show() {
    return window[this.key].show();
  }

  hide() {
    return window[this.key].hide();
  }

  reset() {
    return window[this.key].reset();
  }

  getName() {
    return this.key;
  }
}
